import { render, staticRenderFns } from "./UserRoleForm.vue?vue&type=template&id=4977141e&scoped=true"
import script from "./UserRoleForm.vue?vue&type=script&lang=js"
export * from "./UserRoleForm.vue?vue&type=script&lang=js"
import style0 from "./UserRoleForm.vue?vue&type=style&index=0&id=4977141e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4977141e",
  null
  
)

export default component.exports